import { render, staticRenderFns } from "./SliceUploader.vue?vue&type=template&id=5542529f&scoped=true&"
import script from "./SliceUploader.vue?vue&type=script&lang=ts&"
export * from "./SliceUploader.vue?vue&type=script&lang=ts&"
import style0 from "./SliceUploader.vue?vue&type=style&index=0&id=5542529f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5542529f",
  null
  
)

export default component.exports